import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {getReservationEntityItems as getReservationEntityItemsApi} from '../../../services/entities/entities'
import fixture from '../../../fixtures/get-reservation_entity_items.json'

export async function getReservationEntityItems(dispatch, entity_id, params) {
  try {
    dispatch({type: PENDING, payload: {...params}})
    let response = await getReservationEntityItemsApi(entity_id, params)
    dispatch({type: SUCCESS, payload: {...response, ...params}})
    return response
  } catch (e) {
    console.log(`Get Reservation Entity Items Failed: ${entity_id}`)
    dispatch({type: FAILURE, payload: e})
    return Promise.reject(e)
  }
}
